import React, {useEffect} from 'react';
import {ArenaInfoPreviewComponent} from './parts/arena-info-preview/arena-info-preview.component';
import {GameInfoPreviewComponent} from './parts/game-info-preview/game-info-preview.component';
import {observer} from 'mobx-react';
import {IStickyHandler} from '../../sticky-handler/sticky-handler.interface';
import {Check} from '@sparkware/app-utils';
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";


export interface LobbyGamesInfoComponentProps extends ComponentServicesPick<'lobbyGameInfoPreview'>{
  stickyHandler?: IStickyHandler;
  arenaInfo: {
    previewImage: string;
    title: string;
    description: string;
  }
}

const ComponentBody: React.FC<LobbyGamesInfoComponentProps> = observer((props) => {
    const services = useServices();
    useEffect(() => {
        if(!services.device.isMobile) {
            props.lobbyGameInfoPreview.enableGamePreview();
        }
        
        return () => {
            if(!services.device.isMobile) {
                props.lobbyGameInfoPreview.disableGamePreview();
            }
        }
        
    }, [props.lobbyGameInfoPreview, services.device.isMobile]);


    if (services.device.isMobile) {
        return null;
    }

    let enabledOnPC = services.configuration.data.generalSettings?.gamesPreviewConfig?.enabledOnPC;
    if(Check.isNullOrUndefined(enabledOnPC)) {
        enabledOnPC = true;
    }

    if(!enabledOnPC) {
        return null;
    }

    if (props.lobbyGameInfoPreview.currentPreviewedGame) {
        return (<GameInfoPreviewComponent isSticky={props.stickyHandler?.isSticky} gameInfo={props.lobbyGameInfoPreview.currentPreviewedGame}/>);
    } else {
        return (<ArenaInfoPreviewComponent isSticky={props.stickyHandler?.isSticky} arenaInfo={props.arenaInfo}/>);
    }
    
})

export const PcGameInfoPreviewComponent = withServices(ComponentBody, ['lobbyGameInfoPreview']);
